import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import ComponentTitle from "../../layout/ComponentTitle";
import { apiGetPublications } from "../../../api/ApiPublication";
import BlocPublicationsThumbnail from "./BlocPublicationsThumbnail";
import { CardGroup, Container } from "react-bootstrap";
import { MdAddCircleOutline } from "react-icons/md";
import { Link } from "react-router-dom";
import ComponentSousTitle from "../../layout/ComponentSousTitle";

const ComponentPublications = (props) => {
  const { t } = useTranslation();
  const { limit } = props;
  const { ReduxInstance } = useSelector((state) => state.ReduxInstance);
  const [publications, setPublications] = useState([]);

  const recupPublications = async () => {
    const res = await apiGetPublications(
      ReduxInstance._id,
      limit ? "limit=3&sort[ordre]=-1" : "sort[ordre]=-1"
    );

    setPublications(res.data);
  };

  const BlocPublication = () => {
    return (
      <CardGroup className="disableOverflowContent" id={"overflowPublications"}>
        {publications
          .filter((item) => item.publie === true)
          .map((publication, index) => (
            <BlocPublicationsThumbnail publicationObject={publication} key={index} />
          ))}
        {limit && (
          <Link className=" d-flex align-items-center justify-content-center" to="/inviews">
            <div
              role="button"
              className="seeMoreContributions d-flex align-items-center justify-content-center"
            >
              <MdAddCircleOutline size="3.5em" />
            </div>
          </Link>
        )}
      </CardGroup>
    );
  };

  useEffect(() => {
    recupPublications();
  }, [ReduxInstance]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <>
      {ReduxInstance.modulesActives.includes("publication") &&
        publications.filter((item) => item.publie === true).length > 0 && (
          <>
            {/* page accueil  */}
            {limit && (
              <>
                <ComponentTitle title={t("public.filtres.filtre14")} />
                <BlocPublication />
              </>
            )}
            {/* page inviews  */}
            {!limit && (
              <>
                <Container className="mt-5" fluid>
                  <ComponentSousTitle
                    nom={t("public.filtres.filtre14")}
                    overflowID={"overflowPublications"}
                    overflowDeplieAuDepart={true}
                  />
                  <BlocPublication />
                </Container>
              </>
            )}
          </>
        )}
    </>
  );
};

export default ComponentPublications;
